import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { cabApi } from '../../services/api'
import toast from 'react-hot-toast'
import { Plus, Trash2 } from 'lucide-react'
import { useConfirmDelete } from '../../hooks/useConfirmDelete'

export default function CabAnagrafica() {
  const qc = useQueryClient()
  const { confirmDelete, ConfirmModal } = useConfirmDelete()
  const [showForm, setShowForm] = useState(false)
  const [nuova, setNuova] = useState({ afor: '', nmu: '', descrizione: '', q_nuovo: 'N', q_riparato: 'R', q_lavorato: 'A', q_rigenerato: 'B' })

  const { data: righe = [], isLoading } = useQuery({ queryKey: ['cab-nmu'], queryFn: () => cabApi.nmu.list().then(r => r.data) })

  const createMut = useMutation({
    mutationFn: () => cabApi.nmu.create(nuova),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['cab-nmu'] }); setShowForm(false); toast.success('NMU creata') },
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Errore'),
  })
  const deleteMut = useMutation({
    mutationFn: (id: number) => cabApi.nmu.remove(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['cab-nmu'] }); toast.success('Eliminata') },
  })

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-slate-900">Anagrafica NMU / Quartine</h1>
        <button className="btn-primary flex items-center gap-1.5" onClick={() => setShowForm(v => !v)}><Plus size={14} /> Nuova</button>
      </div>

      {showForm && (
        <div className="card p-4 grid grid-cols-3 sm:grid-cols-7 gap-2 items-end">
          <div><label className="label">AFOR</label><input className="input font-mono" maxLength={4} value={nuova.afor} onChange={e => setNuova(p => ({ ...p, afor: e.target.value.toUpperCase() }))} /></div>
          <div><label className="label">NMU</label><input className="input font-mono" maxLength={6} value={nuova.nmu} onChange={e => setNuova(p => ({ ...p, nmu: e.target.value }))} /></div>
          <div className="col-span-2"><label className="label">Descrizione</label><input className="input" value={nuova.descrizione} onChange={e => setNuova(p => ({ ...p, descrizione: e.target.value }))} /></div>
          {(['q_nuovo', 'q_riparato', 'q_lavorato', 'q_rigenerato'] as const).map(k => (
            <div key={k}><label className="label text-[10px]">{k.replace('q_', '')}</label><input className="input font-mono w-14" maxLength={1} value={(nuova as any)[k]} onChange={e => setNuova(p => ({ ...p, [k]: e.target.value.toUpperCase() }))} /></div>
          ))}
          <button className="btn-primary" disabled={!nuova.afor || !nuova.nmu || createMut.isPending} onClick={() => createMut.mutate()}>Salva</button>
        </div>
      )}

      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-xs text-slate-500 uppercase">
              <th className="text-left px-3 py-2">AFOR</th>
              <th className="text-left px-3 py-2">NMU</th>
              <th className="text-left px-3 py-2">Descrizione</th>
              <th className="text-left px-3 py-2">Quartina (N/R/A/B)</th>
              <th className="text-left px-3 py-2">Attiva</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={6} className="text-center py-8 text-slate-400">Caricamento...</td></tr>}
            {righe.map((r: any) => (
              <tr key={r.id} className="border-t border-slate-100">
                <td className="px-3 py-2 font-mono">{r.afor}</td>
                <td className="px-3 py-2 font-mono">{r.nmu}</td>
                <td className="px-3 py-2">{r.descrizione || '—'}</td>
                <td className="px-3 py-2 font-mono">{r.q_nuovo}/{r.q_riparato}/{r.q_lavorato}/{r.q_rigenerato}</td>
                <td className="px-3 py-2">{r.attiva ? '✓' : '—'}</td>
                <td className="px-3 py-2">
                  <button onClick={() => confirmDelete('Eliminare la riga NMU?', () => deleteMut.mutate(r.id))} className="text-red-500"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {ConfirmModal}
    </div>
  )
}
